function unwrap(value: unknown): unknown {
  if (typeof value !== 'string') return value;
  try {
    const once = JSON.parse(value);
    if (typeof once === 'string') {
      try { return JSON.parse(once); } catch { return once; }
    }
    return once;
  } catch {
    return value;
  }
}

export function parseJsonArray<T>(value: unknown): T[] {
  if (value == null) return [];
  const unwrapped = unwrap(value);
  return Array.isArray(unwrapped) ? (unwrapped as T[]) : [];
}

export function parseNonEmptyJsonArray<T>(value: unknown): T[] {
  const arr = parseJsonArray<T>(value);
  return arr.length > 0 ? arr : [];
}

export function toJsonColumn(value: unknown): string {
  const arr = parseJsonArray(value);
  return JSON.stringify(arr);
}
